import { Stack } from '@koob/margaret';
import styled from 'styled-components';
import { formatDate } from '@koob/dates';

const DateChunk = styled.span`
  text-align: center;
  white-space: nowrap;
`;

const DateRange = ({ startAt, endAt, size }) => (
  <Stack gutterSize={0.5} size={size} alignX="space-between">
    {Boolean(startAt) ? (
      <DateChunk>{formatDate(startAt, 'DD MMM YYYY').toUpperCase()}</DateChunk>
    ) : (
      <DateChunk>--/--/----</DateChunk>
    )}
    <i className="fa-light fa-arrow-right" style={{ fontSize: 20 }} />
    {Boolean(endAt) ? (
      <DateChunk>{formatDate(endAt, 'DD MMM YYYY').toUpperCase()}</DateChunk>
    ) : (
      <DateChunk>--/--/----</DateChunk>
    )}
  </Stack>
);

export default DateRange;
